import ListItemIcon from "@mui/material/ListItemIcon";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { MenuItem, MenuItemWithIcon, MoreHorizMenu, Text } from "designSystem/index";
import ListWithSubheader, { ListSection } from "designSystem/components/list/ListWithSubheader";
import React, { ReactNode } from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";
import { items } from "designSystemLegacy/data";

export default () => {
	const createSection = (sectionName: string): ReactNode => {
		return (
			<>
				{items.filter((x) => x.group === sectionName)
					.map((item) =>
						<MenuItem key={item.id} text={item.name} />)}
			</>
		);
	};

	const createSectionWithIcon = (sectionName: string): ReactNode => {
		return (
			<>
				{items.filter((x) => x.group === sectionName)
					.map((item) => (
						<MenuItemWithIcon
							key={item.id}
							onClick={() => null}
							text={item.name}
						>
							<ListItemIcon> 
								<VisibilityIcon />
							</ListItemIcon>
						</MenuItemWithIcon>
					))}
			</>
		);
	};

	const sectionsWithIcon: ListSection[] = [
		{
			sectionName: "CA",
			sectionBody: createSectionWithIcon("CA"),
		},
		{
			sectionName: "WA",
			sectionBody: createSection("WA"),
		},
		{
			sectionName: "AZ",
			sectionBody: createSection("AZ"),
		},
		{
			sectionName: "CA2",
			sectionBody: createSection("CA"),
		},
		{
			sectionName: "WA2",
			sectionBody: createSection("WA"),
		},
	];

	const sectionsWithoutIcon: ListSection[] = [
		{
			sectionName: "CA",
			sectionBody: createSection("CA"),
		},
		{
			sectionName: "WA",
			sectionBody: createSection("WA"),
		},
		{
			sectionName: "AZ",
			sectionBody: createSection("AZ"),
		},
		{
			sectionName: "CA2",
			sectionBody: createSection("CA"),
		},
		{
			sectionName: "WA2",
			sectionBody: createSection("WA"),
		},
	];

	return (
		<CssColumnGrid columns={2}>
			<Text semiBold text="without icon" />
			<Text semiBold text="with icon" />
			<MoreHorizMenu>
				<ListWithSubheader sections={sectionsWithoutIcon} />
			</MoreHorizMenu>
			<MoreHorizMenu>
				<ListWithSubheader sections={sectionsWithIcon} />
			</MoreHorizMenu>
		</CssColumnGrid>
	);
};